import { render, staticRenderFns } from "./trainPaymentGuide.vue?vue&type=template&id=6bb2194b&"
import script from "./trainPaymentGuide.vue?vue&type=script&lang=ts&"
export * from "./trainPaymentGuide.vue?vue&type=script&lang=ts&"
import style0 from "./trainPaymentGuide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports